/* ==========================================================================
 * Reseller Hub — v3.1 (redesign + site-style + geo default)
 * 相比 v3 新增：
 *   - 字体/圆角接入主题设计 token（Open Sans / 主题变量优先）
 *   - 基于 Shopify request.country（服务端 IP 检测）默认定位到访客国家
 *     优先级：URL hash（可分享链接）> 访客 IP 国家 > 默认第一个区域
 *   - 定位生效时显示可关闭的提示 chip："Showing stores in VIETNAM ✕"
 * ========================================================================== */
(function () {
  'use strict';

  /* ISO 3166-1 alpha-2 → reseller 数据国家 slug 映射 */
  var ISO_MAP = {
    JP: 'japan', SG: 'singapore', TR: 'turkey', HK: 'hong-kong-china',
    ID: 'indonesia', IN: 'india', MY: 'malaysia', TW: 'taiwan-china',
    PK: 'pakistan', SA: 'saudi-arabia', PH: 'philippines', VN: 'vietnam',
    KH: 'cambodia', KR: 'republic-of-korea', KW: 'kuwait', KZ: 'kazakhstan',
    JO: 'jordan', BD: 'bangladesh', TH: 'thailand', QA: 'qatar',
    IL: 'israel', AE: 'united-arab-emirates', LB: 'lebanon', NP: 'nepal',
    ZA: 'south-africa', EG: 'egypt', AU: 'australia', NZ: 'new-zealand',
    AT: 'austria', DE: 'germany', FR: 'france', IT: 'italy',
    NL: 'netherlands', PT: 'portugal', PL: 'poland', GB: 'united-kingdom',
    GR: 'greece', CH: 'switzerland', RU: 'russia', MD: 'moldova',
    BG: 'bulgaria', BY: 'belarus', BE: 'belgium', LT: 'lithuania',
    RS: 'serbia', ES: 'spain', CZ: 'czech', SK: 'slovakia',
    HU: 'hungary', UA: 'ukraine', AR: 'argentina', BR: 'brazil',
    CL: 'chile', CR: 'costa-rica', PE: 'peru', PY: 'paraguay',
    CO: 'colombia', US: 'us', CA: 'canada', MX: 'mexico'
  };

  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('resellerHubGrid');
    var nav = document.getElementById('resellerHubNav');
    var pillsWrap = document.getElementById('resellerHubPillsWrap');
    var pills = document.getElementById('resellerHubPills');
    var searchInput = document.getElementById('resellerHubSearch');
    var countEl = document.getElementById('resellerHubCount');
    var geoEl = document.getElementById('resellerHubGeo');
    var topBtn = document.getElementById('resellerHubTop');

    if (!grid || !nav) return;

    var data = window.resellerData;
    if (!data || !data.regions) {
      grid.innerHTML = noResultsHTML('No store data available.');
      nav.innerHTML = '';
      return;
    }

    var state = { region: data.regions[0].id, country: null, query: '', geo: false };
    var searchTimer = null;

    /* -------------------- 工具 -------------------- */
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function key(c) { return String(c.country).toLowerCase(); }

    function domain(url) {
      try { return new URL(url).hostname.replace(/^www\./, ''); }
      catch (e) { return url; }
    }

    function highlight(text, q) {
      var t = esc(text);
      if (!q) return t;
      var eq = esc(q).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return t.replace(new RegExp('(' + eq + ')', 'ig'), '<mark>$1</mark>');
    }

    function findRegion(id) {
      return data.regions.find(function (r) { return r.id === id; }) || null;
    }

    function findCountry(k) {
      var out = null;
      data.regions.forEach(function (r) {
        r.countries.forEach(function (c) { if (key(c) === k) out = c; });
      });
      return out;
    }

    function byLabel(a, b) { return a.countryLabel.localeCompare(b.countryLabel); }

    function countStores(countries) {
      return countries.reduce(function (n, c) { return n + c.retailers.length; }, 0);
    }

    /* -------------------- 初始化：hash > IP 定位 > 默认 -------------------- */
    (function initState() {
      /* 1. URL hash（分享链接优先，意图最明确） */
      var h = decodeURIComponent(location.hash.replace('#', '')).toLowerCase();
      if (h) {
        for (var i = 0; i < data.regions.length; i++) {
          var r = data.regions[i];
          if (r.id === h) { state.region = h; return; }
          for (var j = 0; j < r.countries.length; j++) {
            if (key(r.countries[j]) === h) {
              state.region = r.id; state.country = h; return;
            }
          }
        }
      }

      /* 2. 访客 IP 国家（Shopify 服务端注入，无第三方请求） */
      var iso = String(window.resellerVisitorCountry || '').toUpperCase();
      var slug = ISO_MAP[iso];
      if (slug) {
        for (var a = 0; a < data.regions.length; a++) {
          var rg = data.regions[a];
          for (var b = 0; b < rg.countries.length; b++) {
            if (key(rg.countries[b]) === slug) {
              state.region = rg.id; state.country = slug; state.geo = true;
              return;
            }
          }
        }
      }

      /* 3. 默认第一个区域 */
    })();

    /* -------------------- 左侧导航 -------------------- */
    function renderNav() {
      var html = '';
      data.regions.forEach(function (r) {
        var active = r.id === state.region && !state.query;
        html += '<button class="rh-region' + (active ? ' active' : '') + '" data-region="' + esc(r.id) + '"'
             +  ' aria-current="' + (active ? 'true' : 'false') + '">'
             +  '<span class="rh-region-label">' + highlight(r.label, state.query) + '</span>'
             +  '<span class="rh-region-count">' + countStores(r.countries) + '</span>'
             +  '</button>';
      });
      nav.innerHTML = html;

      nav.querySelectorAll('.rh-region').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.region = this.getAttribute('data-region');
          state.country = null;
          state.query = '';
          state.geo = false;
          if (searchInput) searchInput.value = '';
          history.replaceState(null, '', '#' + state.region);
          refresh();
        });
      });
    }

    /* -------------------- 国家 pills -------------------- */
    function renderPills() {
      var region = findRegion(state.region);
      if (!region || state.query) {
        if (pillsWrap) pillsWrap.style.display = 'none';
        return;
      }
      if (pillsWrap) pillsWrap.style.display = '';

      var html = '<button class="rh-pill' + (state.country ? '' : ' active') + '" data-country="">All</button>';
      region.countries.slice().sort(byLabel).forEach(function (c) {
        var k = key(c);
        html += '<button class="rh-pill' + (state.country === k ? ' active' : '') + '"'
             +  ' data-country="' + esc(k) + '">'
             +  esc(c.countryLabel) + '</button>';
      });
      pills.innerHTML = html;

      pills.querySelectorAll('.rh-pill').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.country = this.getAttribute('data-country') || null;
          state.geo = false; /* 手动选择即视为覆盖定位 */
          history.replaceState(null, '', state.country ? '#' + state.country : '#' + state.region);
          refresh();
        });
      });
    }

    /* -------------------- 定位提示 chip -------------------- */
    function renderGeoChip() {
      if (!geoEl) return;
      if (!state.geo || state.query || !state.country) { geoEl.hidden = true; return; }
      var c = findCountry(state.country);
      geoEl.hidden = false;
      geoEl.innerHTML = '<span class="rh-geo-pin" aria-hidden="true">&#128205;</span>'
                      + 'Showing stores in <b>' + esc(c ? c.countryLabel : '') + '</b>'
                      + '<span class="rh-geo-x" aria-hidden="true" title="Show all">&#10005;</span>';
      geoEl.onclick = function () {
        state.country = null;
        state.geo = false;
        history.replaceState(null, '', '#' + state.region);
        refresh();
      };
    }

    /* -------------------- 内容渲染 -------------------- */
    function searchAll(q) {
      var out = [];
      data.regions.forEach(function (r) {
        var matched = [];
        r.countries.forEach(function (c) {
          var hits = c.retailers.filter(function (rt) {
            return rt.name.toLowerCase().indexOf(q) !== -1
                || c.countryLabel.toLowerCase().indexOf(q) !== -1;
          });
          if (hits.length) {
            matched.push({ country: c.country, countryLabel: c.countryLabel, retailers: hits });
          }
        });
        if (matched.length) out.push({ id: r.id, label: r.label, countries: matched });
      });
      return out;
    }

    function visibleGroups() {
      if (state.query) return searchAll(state.query);
      var region = findRegion(state.region);
      if (!region) return [];
      var countries = region.countries.slice().sort(byLabel);
      if (state.country) {
        countries = countries.filter(function (c) { return key(c) === state.country; });
      }
      return [{ id: region.id, label: region.label, countries: countries }];
    }

    function cardHTML(retailer, i, q) {
      var delay = Math.min(i, 14) * 40;
      var initial = esc((retailer.name || '?').trim().charAt(0).toUpperCase() || '?');
      return '<a href="' + esc(retailer.url) + '" class="rh-card" target="_blank" rel="noopener noreferrer"'
           + ' style="--stagger:' + delay + '">'
           +   '<div class="rh-card-inner">'
           +     '<div class="rh-logo">'
           +       '<span class="rh-fallback">' + initial + '</span>'
           +       '<img src="' + esc(retailer.logo) + '" alt="' + esc(retailer.name) + '" loading="lazy"'
           +        ' onload="this.classList.add(\'loaded\')" onerror="this.remove()" />'
           +     '</div>'
           +     '<div class="rh-info">'
           +       '<div class="rh-name">' + highlight(retailer.name, q) + '</div>'
           +       '<div class="rh-domain">' + esc(domain(retailer.url)) + '</div>'
           +     '</div>'
           +     '<span class="rh-arrow" aria-hidden="true">&#10142;</span>'
           +   '</div>'
           + '</a>';
    }

    function noResultsHTML(msg) {
      return '<div class="rh-empty">'
           +  '<div class="rh-empty-icon" aria-hidden="true">&#128269;</div>'
           +  '<h3>' + esc(msg) + '</h3>'
           +  (state.query
               ? '<p>Try a store name or country, or <button class="rh-link" id="resellerHubReset">clear the search</button>.</p>'
               : '<p>Please select a region to view available stores.</p>')
           +  '</div>';
    }

    function renderContent() {
      var groups = visibleGroups();
      var html = '';
      var idx = 0;
      var totalStores = 0;

      groups.forEach(function (g) {
        var showRegionTitle = state.query && groups.length > 0;
        html += '<section class="rh-region-section">'
             +  (showRegionTitle ? '<h2 class="rh-region-title">' + highlight(g.label, state.query) + '</h2>' : '');
        g.countries.forEach(function (c) {
          totalStores += c.retailers.length;
          html += '<div class="rh-country">'
               +   '<h3 class="rh-country-title">' + highlight(c.countryLabel, state.query)
               +     '<span class="rh-country-count">' + c.retailers.length + '</span></h3>'
               +   '<div class="rh-grid">';
          c.retailers.forEach(function (rt) { html += cardHTML(rt, idx++, state.query); });
          html += '</div></div>';
        });
        html += '</section>';
      });

      if (!html) {
        html = noResultsHTML(state.query
          ? 'No stores found for \u201C' + esc(state.query) + '\u201D'
          : 'No retailers found');
      }
      grid.innerHTML = html;

      var resetBtn = document.getElementById('resellerHubReset');
      if (resetBtn) resetBtn.addEventListener('click', function () {
        state.query = '';
        if (searchInput) searchInput.value = '';
        refresh();
      });

      if (countEl) {
        if (state.query) {
          countEl.textContent = totalStores + (totalStores === 1 ? ' store matched' : ' stores matched');
        } else {
          var nCountries = groups.length ? groups[0].countries.length : 0;
          countEl.textContent = nCountries + (nCountries === 1 ? ' country · ' : ' countries · ')
                              + totalStores + (totalStores === 1 ? ' store' : ' stores');
        }
      }
    }

    /* -------------------- 搜索 -------------------- */
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var v = this.value.trim();
        searchTimer = setTimeout(function () {
          state.query = v.toLowerCase();
          refresh();
        }, 120);
      });
    }

    /* -------------------- 回到顶部 -------------------- */
    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      window.addEventListener('scroll', function () {
        topBtn.classList.toggle('show', window.scrollY > 900);
      }, { passive: true });
    }

    function refresh() {
      renderNav();
      renderPills();
      renderGeoChip();
      renderContent();
    }

    refresh();
  });
})();
